import { IdleTimeoutDialog } from "@/components/chat/idle-timeout-dialog";
import { ChannelHeader } from "@/components/conversations/channel-header";
import { MessageInput } from "@/components/conversations/message-input";
import { HubStoreProvider } from "@/components/hub/use-hub-store";
import { ChannelDetails } from "@/components/sendbird-chat/channel-details";
import { Button } from "@/components/ui/button";
import {
  MentorshipDetails,
  useGetMentorship,
  useUpdateMentorshipOverride,
} from "@/lib/api/mentorships";
import { ChannelProvider } from "@sendbird/uikit-react/Channel/context";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/_admin_chat/chat/$mentorshipId")({
  component: ChatTakeoverView,
});

function ChatTakeoverView() {
  const { mentorshipId } = useParams({
    from: "/_admin_chat/chat/$mentorshipId",
  });

  const { data: mentorship } = useGetMentorship(mentorshipId);
  const updateOverride = useUpdateMentorshipOverride(mentorshipId);

  const closeWindow = async () => {
    try {
      await updateOverride.mutateAsync(false);
    } finally {
      window.close();
    }
  };

  if (!mentorship) return null;

  return (
    <HubStoreProvider>
      <div style={{ height: "100vh", display: "flex" }}>
        <ChannelProvider
          channelUrl={mentorship.sdk_url!}
          replyType="QUOTE_REPLY"
        >
          <ConversationDetails
            mentorship={mentorship}
            onEndOverride={closeWindow}
          />
        </ChannelProvider>
      </div>

      <IdleTimeoutDialog onClose={() => true} onTimeout={closeWindow} />
    </HubStoreProvider>
  );
}

function ConversationDetails({
  mentorship,
  onEndOverride,
}: {
  mentorship: MentorshipDetails;
  onEndOverride: () => void;
}) {
  return (
    <ChannelDetails
      currentChannelUrl={mentorship.sdk_url!}
      channelHeader={
        <div className="flex w-full items-center justify-between">
          <ChannelHeader
            isOverridden
            isSupervisorChannel={false}
            rightElement={
              mentorship.metadata?.override?.isOverridden && (
                <Button variant="destructive" size="sm" onClick={onEndOverride}>
                  End Override
                </Button>
              )
            }
          />
        </div>
      }
      messageInput={
        <MessageInput shouldShowAiConversation={false} isAdminView />
      }
    />
  );
}
